import React from "react";
import { Table, Input } from "reactstrap";
import { formatDate } from "../../../Utils/format-date.js";
import Layout from "../Layout/Layout";
import Modal from "../../../Components/Modals/modal";
import CreateGoal from "./Create-Goal-Modal/Create-Goal";
import EditGoal from "./Edit-Goal/EditGoal";
import GoalSettingWorksheetsLogo from "../../../../images/new-images/goalseetingworksheet.png";
import Edit from "../../../../images/new-images/edit-green.svg";
import "./Goal-Setting-Worksheets.css";

const GoalSettingWorksheets = (props) => {
  return (
    <Layout
      headerIcon={GoalSettingWorksheetsLogo}
      headerText="My Worksheet"
      button="CREATE NEW WORKSHEET"
      click={props.handleCreateModal}
    >
      <div className="my-worksheet">
        <Modal
          assessmentModal={props.createModal}
          handleModalClose={props.handleModalClose}
          modalHeading="ADD WORKSHEET"
        >
          <CreateGoal
            date={props.date}
            handleModalClose={props.handleModalClose}
          />
        </Modal>

        <div className="search-bar">
          <input
            className="search-field"
            type="search"
            placeholder="Search..."
            onChange={(e) => props.handleSearchInput(e.target.value)}
          />
          <Input
            className="drop-down"
            type="select"
            onChange={(e) => props.handleSelectOption(e.target.value)}
          >
            <option value="all">ALL</option>
            <option value="worksheet name">WORKSHEET NAME</option>
            <option value="orientation">ORIENTATION</option>
            <option value="assessment date">ASSESSMENT DATE</option>
          </Input>
        </div>

        <div className="table-wrapper">
          <Table>
            <thead>
              <tr>
                <th>WORKSHEET NAME</th>
                <th>ORIENTATION </th>
                <th>ASSESSMENT DATE </th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {props.noData && (
                  <td colspan="5" className="text-center">
                    No Data Found
                  </td>
                )}
              </tr>
              {props.resp.map((orientation, index) => {
                return (
                  <tr key={index}>
                    <td
                      onClick={() => props.handleManageWorksheet(orientation)}
                    >
                      {orientation.worksheet_name}
                    </td>
                    <td>{orientation.orientation__orientation_name}</td>
                    <td>{formatDate(orientation.assessment__created)}</td>
                    <td>
                      <img
                        onClick={() =>
                          props.handleEditModal(
                            orientation.worksheet_name,
                            orientation.orientation__orientation_name,
                            orientation.assessment__created
                          )
                        }
                        className="edit-icon"
                        src={Edit}
                      />
                    </td>
                    <Modal
                      assessmentModal={props.editModal}
                      handleModalClose={props.handleModalClose}
                      modalHeading="EDIT WORKSHEET"
                    >
                      <EditGoal
                        name={props.name}
                        orientation={props.orientation}
                        date={props.date}
                        handleModalClose={props.handleModalClose}
                      />
                    </Modal>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </Layout>
  );
};

export default GoalSettingWorksheets;



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Goal-Setting-Worksheets/Goal-Setting-Worksheets.jsx